import { getDateForDaysAhead } from "./utils";

const defaultStartDate = getDateForDaysAhead(15);

export const initialState = {
    isInitialized: false, // To keep track of when we should start saving to localstorage.
    isLoading: false,
    electricityContractProducts: [],
    electricityMeasurementTypes: [],
    billingIntervalsList: [],
    housingTypes: [],
    spotPrice: null,
    presetHousingType: null,
    isFormValid: false,
    formStage: 1,
    formVerificationStage: false,
    error: false,
    errorMessage: null,
    isAuthenticated: false,
    form: {
        selectedHousingType: null,
        selectedMeasurementType: null,
        selectedProduct: null,
        yearlyTotal: null,
        registration: {
            firstName: null,
            lastName: null,
            phoneNumber: null,
            email: null,
            streetAddress: null,
            zip: null,
            city: null,
            startDate: defaultStartDate,
            isNewAddress: false,
            placeOfUseNumber: null,
            electricityPlan: null,
            agreement: null,
            estimatedUsage: null,
            selectedInterval: null,
            billingAddressSameAsMail: true,
            billingAddress: null,
            billingAreaCode: null,
            billingTown: null,
            multiPersonContract: false,
            secondPersonFirstName: null,
            secondPersonLastName: null,
            secondPersonEmail: null,
            secondPersonSocialSecurityNumber: null,
        },
        multiPersonRegistration: {
            firstName: null,
            lastName: null,
            phoneNumber: null,
            email: null,
            streetAddress: null,
            zip: null,
            city: null,
            startDate: defaultStartDate,
            isNewAddress: false,
            placeOfUseNumber: null,
            electricityPlan: null,
            agreement: null,
            estimatedUsage: null,
            selectedInterval: null,
            billingAddressSameAsMail: true,
            billingAddress: null,
            billingAreaCode: null,
            billingTown: null,
            multiPersonContract: false,
            secondPersonFirstName: null,
            secondPersonLastName: null,
            secondPersonEmail: null,
            secondPersonSocialSecurityNumber: null,
            uuid: null,
            productID:null,
        },
        optional: {
            voucher: null,
            moreInfo: null,
        }
    },
    slider: {
        value: 2000,
        options: {
            dotSize: [25, 25],
            width: 'auto',
            height: 10,
            contained: false,
            direction: 'ltr',
            data: null,
            min: 0,
            max: 50000,
            interval: 100,
            disabled: false,
            clickable: true,
            duration: 0.5,
            adsorb: false,
            lazy: false,
            tooltip: 'always',
            tooltipPlacement: 'bottom',
            useKeyboard: false,
            enableCross: true,
            fixed: false,
            minRange: void 0,
            maxRange: void 0,
            order: true,
            marks: false,
            dotOptions: void 0,
            process: true,
            dotStyle: void 0,
            railStyle: void 0,
            processStyle: void 0,
            tooltipStyle: void 0,
            stepStyle: void 0,
            stepActiveStyle: void 0,
            labelStyle: void 0,
            labelActiveStyle: void 0,
        }
    },
    carousel: {
        options: {
            height: 500
        }
    },
    datepicker: {
        options: {
            mondayFirst: true,
            required: true,
            bootstrapStyling: true,
            calendarButton: true,
            clearButton: true,
        }
    }
};
